export const heroData = {
  title: "6789影视",
  subtitle: "最新综艺在线观看，每日更新不等待",
  description: "搞笑综艺、真人秀综艺、音乐综艺、脱口秀——高清流畅，免费全集，紧跟每期精彩内容",
  ctaText: "立即观看",
  ctaLink: "/category/remen",
  bgImage: "https://readdy.ai/api/search-image?query=A%20vibrant%20abstract%20entertainment%20background%20with%20warm%20coral%20and%20amber%20gradients%2C%20soft%20geometric%20shapes%2C%20cinematic%20atmosphere%2C%20modern%20streaming%20platform%20vibe%2C%20playful%20yet%20professional%20aesthetic%2C%20smooth%20color%20transitions%2C%20no%20text%2C%20clean%20and%20inviting%20visual%20style%20with%20subtle%20light%20effects&width=1600&height=900&seq=hero-6789-2026&orientation=landscape",
};

export const categories = [
  {
    slug: "gaoxiao",
    name: "搞笑综艺",
    icon: "ri-emotion-laugh-line",
    count: 128,
    description: "爆笑不断，欢乐无限",
    color: "primary",
  },
  {
    slug: "zhenrenxiu",
    name: "真人秀综艺",
    icon: "ri-camera-line",
    count: 96,
    description: "真实记录，精彩瞬间",
    color: "accent",
  },
  {
    slug: "yinyue",
    name: "音乐综艺",
    icon: "ri-music-line",
    count: 74,
    description: "旋律飞扬，声入人心",
    color: "secondary",
  },
  {
    slug: "tuokouxiu",
    name: "脱口秀",
    icon: "ri-chat-smile-2-line",
    count: 56,
    description: "妙语连珠，笑料不断",
    color: "primary",
  },
  {
    slug: "jingji",
    name: "竞技综艺",
    icon: "ri-trophy-line",
    count: 63,
    description: "巅峰对决，热血沸腾",
    color: "accent",
  },
  {
    slug: "lvxing",
    name: "旅行综艺",
    icon: "ri-earth-line",
    count: 42,
    description: "环游世界，美景相伴",
    color: "secondary",
  },
];

export const hotContent = [
  {
    id: 1,
    title: "笑傲江湖 第十季",
    category: "搞笑综艺",
    categorySlug: "gaoxiao",
    image: "https://readdy.ai/api/search-image?query=A%20comedy%20variety%20show%20poster%20with%20bright%20stage%20lights%2C%20comedians%20performing%20on%20stage%2C%20warm%20and%20energetic%20atmosphere%2C%20red%20and%20gold%20color%20scheme%2C%20Chinese%20entertainment%20style%2C%20professional%20TV%20show%20photography&width=600&height=400&seq=hot-1-6789&orientation=landscape",
    description: "国内顶尖喜剧人齐聚一堂，带来最爆笑的舞台表演，笑点密集不容错过",
    views: "1.2亿",
    rating: 9.5,
    episode: "更新至第12期",
    date: "2026-07-28",
    badge: "热门",
  },
  {
    id: 2,
    title: "奔跑吧·勇往直前",
    category: "真人秀综艺",
    categorySlug: "zhenrenxiu",
    image: "https://readdy.ai/api/search-image?query=An%20outdoor%20adventure%20reality%20show%20scene%20with%20celebrities%20running%20in%20a%20beautiful%20natural%20landscape%2C%20sunny%20day%2C%20dynamic%20action%20shot%2C%20Chinese%20variety%20show%20style%2C%20energetic%20and%20fun%20atmosphere&width=600&height=400&seq=hot-2-6789&orientation=landscape",
    description: "明星嘉宾集结，挑战极限任务，笑料与感动并存的全新一季",
    views: "9850万",
    rating: 9.3,
    episode: "更新至第8期",
    date: "2026-07-30",
    badge: "热播",
  },
  {
    id: 3,
    title: "中国好声音 2026",
    category: "音乐综艺",
    categorySlug: "yinyue",
    image: "https://readdy.ai/api/search-image?query=A%20music%20talent%20show%20stage%20with%20dramatic%20lighting%2C%20a%20singer%20performing%20under%20spotlight%2C%20grand%20stage%20design%2C%20Chinese%20singing%20competition%2C%20professional%20TV%20production%20quality%2C%20emotional%20atmosphere&width=600&height=400&seq=hot-3-6789&orientation=landscape",
    description: "四位重量级导师转身抢人，新声代唱将实力对决，音乐盛典再度开启",
    views: "1.5亿",
    rating: 9.6,
    episode: "更新至第6期",
    date: "2026-08-01",
    badge: "推荐",
  },
  {
    id: 4,
    title: "吐槽大会 第七季",
    category: "脱口秀",
    categorySlug: "tuokouxiu",
    image: "https://readdy.ai/api/search-image?query=A%20stand-up%20comedy%20talk%20show%20stage%20with%20a%20comedian%20holding%20a%20microphone%2C%20spotlight%20on%20stage%2C%20audience%20laughing%2C%20modern%20studio%20setting%2C%20Chinese%20comedy%20show%2C%20warm%20and%20lively%20atmosphere&width=600&height=400&seq=hot-4-6789&orientation=landscape",
    description: "最辛辣的吐槽，最幽默的表达，明星嘉宾互相爆料笑翻全场",
    views: "8750万",
    rating: 9.1,
    episode: "更新至第10期",
    date: "2026-07-25",
    badge: "热门",
  },
  {
    id: 5,
    title: "极限挑战 第十二季",
    category: "竞技综艺",
    categorySlug: "jingji",
    image: "https://readdy.ai/api/search-image?query=A%20competitive%20variety%20show%20with%20celebrities%20doing%20challenging%20missions%20in%20an%20urban%20setting%2C%20action-packed%20scene%2C%20teamwork%20vibe%2C%20Chinese%20reality%20competition%2C%20dynamic%20and%20exciting%20atmosphere&width=600&height=400&seq=hot-5-6789&orientation=landscape",
    description: "极限男人帮全新阵容，城市挑战升级，智慧与体力的双重考验",
    views: "1.1亿",
    rating: 9.4,
    episode: "更新至第9期",
    date: "2026-07-27",
    badge: "热播",
  },
  {
    id: 6,
    title: "花少看世界 第六季",
    category: "旅行综艺",
    categorySlug: "lvxing",
    image: "https://readdy.ai/api/search-image?query=A%20travel%20variety%20show%20featuring%20celebrities%20exploring%20an%20exotic%20destination%2C%20beautiful%20scenery%2C%20group%20travel%20vibe%2C%20sunny%20day%2C%20Chinese%20travel%20reality%20show%2C%20warm%20and%20adventurous%20atmosphere&width=600&height=400&seq=hot-6-6789&orientation=landscape",
    description: "明星旅行团踏上全新旅程，异国风情、美食探索、温情互动",
    views: "7650万",
    rating: 9.0,
    episode: "更新至第7期",
    date: "2026-07-29",
    badge: "推荐",
  },
];

export const latestUpdates = [
  {
    id: 7,
    title: "王牌对王牌 第九季 第12期：沈腾贾玲爆笑对决",
    category: "搞笑综艺",
    categorySlug: "gaoxiao",
    image: "https://readdy.ai/api/search-image?query=A%20game%20variety%20show%20with%20two%20teams%20of%20celebrities%20competing%20in%20funny%20games%20on%20a%20colorful%20stage%2C%20bright%20lighting%2C%20comedic%20expressions%2C%20Chinese%20TV%20entertainment%2C%20energetic%20and%20playful%20vibe&width=600&height=400&seq=latest-1-6789&orientation=landscape",
    time: "2小时前",
    views: "520万",
  },
  {
    id: 8,
    title: "向往的生活 第八季 第8期：田园音乐会",
    category: "真人秀综艺",
    categorySlug: "zhenrenxiu",
    image: "https://readdy.ai/api/search-image?query=A%20peaceful%20countryside%20setting%20with%20celebrities%20enjoying%20rural%20life%2C%20cooking%20and%20music%20in%20a%20traditional%20Chinese%20courtyard%2C%20warm%20natural%20lighting%2C%20slow%20living%20reality%20show%20style&width=600&height=400&seq=latest-2-6789&orientation=landscape",
    time: "5小时前",
    views: "380万",
  },
  {
    id: 9,
    title: "歌手2026 第8期：巅峰踢馆赛",
    category: "音乐综艺",
    categorySlug: "yinyue",
    image: "https://readdy.ai/api/search-image?query=A%20professional%20singer%20performing%20on%20a%20grand%20stage%20with%20elaborate%20lighting%20and%20visual%20effects%2C%20dramatic%20atmosphere%2C%20Chinese%20singing%20competition%2C%20high-end%20TV%20production%2C%20emotional%20performance%20moment&width=600&height=400&seq=latest-3-6789&orientation=landscape",
    time: "8小时前",
    views: "680万",
  },
  {
    id: 10,
    title: "这！就是街舞 第七季 第6期：战队大秀",
    category: "竞技综艺",
    categorySlug: "jingji",
    image: "https://readdy.ai/api/search-image?query=A%20street%20dance%20competition%20with%20dancers%20performing%20energetic%20choreography%20on%20a%20futuristic%20stage%2C%20dynamic%20movement%2C%20urban%20style%2C%20Chinese%20dance%20reality%20show%2C%20vibrant%20and%20powerful%20atmosphere&width=600&height=400&seq=latest-4-6789&orientation=landscape",
    time: "12小时前",
    views: "450万",
  },
  {
    id: 11,
    title: "脱口秀大会 第六季 第10期：总决赛",
    category: "脱口秀",
    categorySlug: "tuokouxiu",
    image: "https://readdy.ai/api/search-image?query=A%20stand-up%20comedian%20delivering%20a%20punchline%20on%20stage%20at%20a%20comedy%20club%20setting%2C%20spotlight%2C%20audience%20reaction%2C%20Chinese%20comedy%20show%2C%20intimate%20and%20lively%20atmosphere&width=600&height=400&seq=latest-5-6789&orientation=landscape",
    time: "1天前",
    views: "920万",
  },
  {
    id: 12,
    title: "青春环游记 第五季 第5期：古城探秘",
    category: "旅行综艺",
    categorySlug: "lvxing",
    image: "https://readdy.ai/api/search-image?query=Celebrities%20exploring%20an%20ancient%20Chinese%20town%20with%20traditional%20architecture%2C%20cultural%20activities%2C%20group%20travel%20fun%2C%20Chinese%20travel%20variety%20show%2C%20warm%20and%20nostalgic%20atmosphere&width=600&height=400&seq=latest-6-6789&orientation=landscape",
    time: "1天前",
    views: "310万",
  },
];

export const featuredContent = [
  {
    id: 13,
    title: "德云社相声专场 2026",
    category: "搞笑综艺",
    categorySlug: "gaoxiao",
    image: "https://readdy.ai/api/search-image?query=A%20traditional%20Chinese%20crosstalk%20comedy%20performance%20with%20two%20performers%20in%20traditional%20robes%20on%20a%20decorated%20stage%2C%20warm%20lighting%2C%20Chinese%20cultural%20entertainment%2C%20elegant%20and%20humorous%20atmosphere&width=800&height=500&seq=featured-1-6789&orientation=landscape",
    description: "德云社年度相声盛典，郭德纲于谦领衔主演，传统艺术焕发新生",
    badgeText: "独家",
  },
  {
    id: 14,
    title: "乘风破浪的姐姐 第五季",
    category: "真人秀综艺",
    categorySlug: "zhenrenxiu",
    image: "https://readdy.ai/api/search-image?query=A%20group%20of%20elegant%20female%20celebrities%20on%20a%20glamorous%20stage%2C%20performing%20in%20stunning%20outfits%2C%20powerful%20and%20confident%20energy%2C%20Chinese%20reality%20show%2C%20sophisticated%20and%20empowering%20atmosphere&width=800&height=500&seq=featured-2-6789&orientation=landscape",
    description: "30位姐姐重返舞台，唱跳演绎女性力量，精彩舞台不容错过",
    badgeText: "热播",
  },
];

export const stats = [
  { label: "综艺节目", value: "5000+", icon: "ri-movie-line" },
  { label: "每日更新", value: "50+", icon: "ri-calendar-check-line" },
  { label: "高清流畅", value: "1080P", icon: "ri-4k-line" },
  { label: "用户好评", value: "99%", icon: "ri-heart-line" },
];